/**
 * Licensee User Model
 */

define(function(require) {
    'use strict';

    var UserModel = require('modules/user/spanish-regulations/user.model');

    return UserModel.extend({

        getDefaultPlayerFields: function() {
            var playerFields = UserModel.prototype.getDefaultPlayerFields.apply(this, arguments);

            // in addition to spanish regulations
            return playerFields.concat(87, 88);
        },
        // Fix for prevent "Fast registration"
        isFastRegistered: function() {
            return false;
        }
    });
});
